<template>
    <b-modal
        :id="`modal-form-${modalId}`"
        ref="modal"
        :title="modalTitle"
        size="md"
        cancel-variant="light"
        ok-variant="primary"
        :cancel-title="$t('cancel')"
        :ok-title="$t('next')"
        :busy="submitting"
        static
        @ok.prevent="handleSubmit()"
        @show="resetData()"
        @hidden="resetData()"
    >
        <b-overlay :show="submitting" opacity="0" class="h-100">
            <b-form @submit.prevent>

                <FormValidator :validator="$v.form.space" form-group v-slot="slotProps" :label="$t('selectWebsite')" :attribute="$t('space')">
                    <MultiselectSpaces
                        :initial-value="form.space"
                        :show-checkboxes="false"
                        :multiple="false"
                        :close-on-select="true"
                        :clear-on-select="true"
                        :state="slotProps.state"
                        :placeholder="$t('selectField.placeholder')"
                        @inputTrackBy="form.space = $event"
                    />
                </FormValidator>

                <FormValidator :validator="$v.form.name" form-group v-slot="slotProps" :label="$t('enterConfigurationName')" :attribute="$t('name')">
                    <b-form-input v-model="form.name" :disabled="submitting" :state="slotProps.state" :placeholder="$t('enterYourName')" />
                </FormValidator>

            </b-form>
        </b-overlay>
    </b-modal>
</template>



<script>
    import { required } from 'vuelidate/lib/validators';
    import ModalFormMixin from '@/mixins/modalFormMixin';
    import FormValidator from '@/components/common/FormValidator.vue';
    import MultiselectSpaces from '@/components/common/MultiselectSpaces.vue';

    export default {
        name: 'ModalAddConfiguration',
        mixins: [ModalFormMixin],
        components: {
            FormValidator,
            MultiselectSpaces,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                modalId: 'buyboxes-spaces',
                form: {
                    space: Number.parseInt(this.$route.query.space) || null,
                    name: '',
                },
            };
        },
        computed: {
            createAction() {
                return this.$req('buyboxes/Spaces').post;
            },
            formValidations() {
                return {
                    form: {
                        space: { required },
                        name: { required },
                    },
                };
            },
            modalTitle() {
                return this.$t('addConfiguration');
            },
            apiParams() {
                return { requestParams: { name: this.form.name }, urlParams: { id: this.form.space } };
            },
        },
        methods: {
            getDataStructure(data) {
                return { name: data.name };
            },
            refreshData() {
                this.parentComponent.fetchData();
            },
            afterSuccess(data) {
                this.$router.push({ name: 'WidgetSettingsEdit', params: { id: data.id } });
            },
        },
    };
</script>
